$(document).ready(function(){

	var options = {
	  items:1,
	  loop: true,
	  dots: false,
	  nav: true,
	  autoplay:true,
	  stopOnHover: true,
	};
	
	$('.owl-bigHero').owlCarousel(options);

});

